import { Navigate, useLocation } from "react-router-dom";

export default function RedirectRoot({ to }: { to: string }) {
  const location = useLocation();

  return <Navigate replace to={{ ...location, pathname: to }} />;
}
